import find from 'lodash/find'
import { getRepoforId } from '../getRepoforId'
import { getLinkForRepo } from '../getLinkForRepo'
import { getDocumentType } from './getDocumentType'

// Link for a folder segment. Folders inside a pack live under the pack route;
// otherwise they live in the personal library. Mirrors getPathForHit's folder
// branch so a path segment and the row's own navigation resolve identically.
function folderLink(repo, repoId, folderId) {
  if (repo) return `${getLinkForRepo(repo)}/${folderId}`
  if (repoId) return `/packs/${repoId}/${folderId}`
  return `/library/${folderId}`
}

// Returns the ordered root -> leaf breadcrumb leading to an item (excluding the
// item itself) as a list of clickable { id, label, to } segments.
//
// - set / question: pack (if any) then the containing folder chain
//   (ancestors root -> leaf, then the containing folder itself).
// - folder: pack (if any) then its own ancestors (root -> leaf), excluding
//   the folder itself.
//
// Folder `ancestors` are stored leaf -> root, so they are reversed for display
// (matching RepoPageHeaders).
export function getItemPathSegments(item, folders) {
  if (!item) return []
  const allFolders = Array.isArray(folders) ? folders : []
  const kind = getDocumentType(item)
  const segments = []

  let repo = null
  if (item.repo) {
    repo = getRepoforId(item.repo)
    if (repo) {
      const to = getLinkForRepo(repo)
      if (to) segments.push({ id: repo.id, label: repo.name || 'Untitled Pack', to })
    }
  }

  let chainFolders = []
  if (kind === 'folder') {
    const ancestorIds = ((item.ancestors || []).slice()).reverse()
    chainFolders = ancestorIds.map((id) => find(allFolders, { id })).filter(Boolean)
  } else {
    const containingId = item.folder
    if (containingId) {
      const containing = find(allFolders, { id: containingId })
      if (containing) {
        const ancestorIds = ((containing.ancestors || []).slice()).reverse()
        const ancestors = ancestorIds.map((id) => find(allFolders, { id })).filter(Boolean)
        chainFolders = ancestors.concat([containing])
      }
    }
  }

  chainFolders.forEach((f) => {
    const to = folderLink(repo, item.repo, f.id)
    if (to) segments.push({ id: f.id, label: f.name || 'Untitled Folder', to })
  })

  return segments
}
